import { ObservationLink } from "./observation-links";
import {
	ObservationOfTypeFallDto,
	ObservationOfTypeIncontinenceDto,
	ObservationOfTypeInfectionDto,
	ObservationOfTypeNutritionAndHydrationDto,
	ObservationOfTypeOtherDto,
	ObservationOfTypePhysicalComplaintDto,
	ObservationSummaryDto,
} from "./observations.dto";

export type ObservationLinkTypeDto = "CAUSED_BY" | "CONSEQUENCE";

export interface ObservationLinkDto {
	source: string;
	target: string;
	relation: ObservationLinkTypeDto;
}

export interface LinkedObservationDto {
	id: string;
	linkType: ObservationLinkTypeDto;
	observationSummary: ObservationSummaryDto;
}

export interface ObservationLinksDto {
	linkedObservations: LinkedObservationDto[];
}

export type ObservationOfTypeFallWithLinksDto = ObservationOfTypeFallDto & ObservationLinksDto;

export type ObservationOfTypeIncontinenceWithLinksDto = ObservationOfTypeIncontinenceDto & ObservationLinksDto;

export type ObservationOfTypeInfectionWithLinksDto = ObservationOfTypeInfectionDto & ObservationLinksDto;

export type ObservationOfTypeOtherWithLinksDto = ObservationOfTypeOtherDto & ObservationLinksDto;

export type ObservationOfTypePhysicalComplaintWithLinksDto = ObservationOfTypePhysicalComplaintDto
	& ObservationLinksDto;

export type ObservationOfTypeNutritionAndHydrationWithLinksDto = ObservationOfTypeNutritionAndHydrationDto
	& ObservationLinksDto;

export function observationLinkToDto(observationLink: ObservationLink): ObservationLinkDto {
	return {
		source: observationLink.sourceObservationId,
		target: observationLink.targetObservationId,
		relation: observationLink.linkType,
	};
}
